import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
import { IAdSetupInfo } from 'tag/ts/tag/interfaces/ads/IAdSetupInfo';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { FWCustomParams } from 'tag/ts/tag/model/ads/freewheel/FWCustomParams';
import { FWGlobalParams } from 'tag/ts/tag/model/ads/freewheel/FWGlobalParams';
import { FWSiteParams } from 'tag/ts/tag/model/ads/freewheel/FWSiteParams';
import { TFWParams } from 'tag/ts/tag/types/ads/freewheel/TFWParams';

/**
 * @copyright © Paramount Streaming
 * @description Contains all data needed to make Freewheel streaming ad calls
 */
export class FreewheelModel extends AbstractFreewheelClass {

	readonly #globalParams: FWGlobalParams;
	readonly #siteParams: FWSiteParams;
	readonly #customParams: FWCustomParams;
	readonly #adParams: TFWParams;
	readonly #adSetupInfo: IAdSetupInfo;

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name:'FreewheelModel'
			}
		);

		// get ad setup info
		this.#adSetupInfo = argument?.tag?.model?.adUtilities?.adSetupInfo();
		this.#globalParams = new FWGlobalParams( { tag: argument?.tag, adSetupInfo: this.#adSetupInfo } );
		this.#siteParams = new FWSiteParams( { tag: argument?.tag, adSetupInfo: this.#adSetupInfo } );
		this.#customParams = new FWCustomParams( { tag: argument?.tag, adSetupInfo: this.#adSetupInfo } );
		this.#adParams = {
			...( this.#globalParams.adParameters || {} ),
			...( this.#siteParams.adParameters || {} ),
			...( this.#customParams.adParameters || {} )
		};
	}

	/**
	 * @description Returns global parameters
	 * @returns {FWGlobalParams}
	 */
	get globalParams(): FWGlobalParams {
		return this.#globalParams;
	}

	/**
	 * @description Returns site parameters
	 * @returns {FWSiteParams}
	 */
	get siteParams(): FWSiteParams {
		return this.#siteParams;
	}

	/**
	 * @description Returns custom parameters
	 * @returns {FWCustomParams}
	 */
	get customParams(): FWCustomParams {
		return this.#customParams;
	}

	/**
	 * @description Returns Ad setup info
	 * @returns {IAdSetupInfo}
	 */
	get adSetupInfo(): IAdSetupInfo {
		return this.#adSetupInfo;
	}

	/**
	 * @description Returns all Freewheel parameters
	 * @returns {TFWParams}
	 */
	get adParameters(): TFWParams {
		return this.#adParams;
	}
}